import { type PropsWithChildren, useMemo } from 'react';

import { env } from '@/config/env';
import { authService } from '@/features/auth/services/authServiceFactory';
import { ApiClient } from '@/lib/api';
import { useAdminCatalogApi } from '../../context';
import { HttpAdminCatalogMediaApi } from '../api';
import {
  MockAdminCatalogMediaApi,
  MockCatalogMediaUploadTransport,
} from '../api/MockAdminCatalogMediaApi';
import { BrowserCatalogMediaUploadTransport } from '../services';
import { CatalogMediaContext, type CatalogMediaContextValue } from './catalogMediaContext';

export function CatalogMediaProvider({
  children,
  value,
}: PropsWithChildren<{ value?: CatalogMediaContextValue }>) {
  const catalog = useAdminCatalogApi();
  const composition = useMemo(() => {
    if (value) return value;
    if (env.catalogDataSource === 'mock') {
      const api = new MockAdminCatalogMediaApi(catalog);
      return { api, transport: new MockCatalogMediaUploadTransport(api) };
    }
    return {
      api: new HttpAdminCatalogMediaApi(new ApiClient(env.apiBaseUrl, authService)),
      transport: new BrowserCatalogMediaUploadTransport(),
    };
  }, [catalog, value]);
  return (
    <CatalogMediaContext.Provider value={composition}>{children}</CatalogMediaContext.Provider>
  );
}
